var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "menu-stat-v3",
    },
    [
      _c("div", { staticClass: "stat-section-header" }, [
        _vm._m(0),
        _c("div", { staticClass: "header-badge-group" }, [
          _c("span", { staticClass: "live-indicator" }, [
            _c("span", { staticClass: "pulse-dot" }),
            _vm._v(
              "\n        Đã đăng: " +
                _vm._s(_vm.hasData ? _vm.report.publishedClasses : "—") +
                "/" +
                _vm._s(_vm.hasData ? _vm.report.totalClasses : "—") +
                " lớp\n        (" +
                _vm._s(_vm.hasData ? _vm.report.publishRate.toFixed(1) : "—") +
                "%)\n      "
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "filter-control-bar" }, [
        _c("div", { staticClass: "filter-left" }, [
          _c(
            "div",
            { staticClass: "filter-chip" },
            [
              _vm._m(1),
              _c("el-date-picker", {
                staticClass: "week-picker",
                attrs: {
                  type: "week",
                  size: "small",
                  format: "Tuần WW (yyyy)",
                  placeholder: "Chọn tuần xem",
                  clearable: false,
                },
                on: { change: _vm.loadReport },
                model: {
                  value: _vm.selectedWeekDate,
                  callback: function ($$v) {
                    _vm.selectedWeekDate = $$v
                  },
                  expression: "selectedWeekDate",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "week-nav-btn-group" }, [
            _c(
              "button",
              {
                staticClass: "nav-arrow-btn",
                attrs: { title: "Tuần trước" },
                on: {
                  click: function ($event) {
                    return _vm.changeWeek(-1)
                  },
                },
              },
              [_c("i", { staticClass: "el-icon-arrow-left" })]
            ),
            _c(
              "button",
              {
                staticClass: "nav-current-btn",
                on: { click: _vm.currentWeek },
              },
              [_vm._v("Tuần này")]
            ),
            _c(
              "button",
              {
                staticClass: "nav-arrow-btn",
                attrs: { title: "Tuần sau" },
                on: {
                  click: function ($event) {
                    return _vm.changeWeek(1)
                  },
                },
              },
              [_c("i", { staticClass: "el-icon-arrow-right" })]
            ),
          ]),
          _c("div", { staticClass: "week-range-tag" }, [
            _c("i", { staticClass: "el-icon-calendar" }),
            _c("span", [_vm._v(_vm._s(_vm.weekRangeLabel))]),
          ]),
          _c(
            "div",
            { staticClass: "filter-chip" },
            [
              _vm._m(2),
              _c(
                "el-select",
                {
                  staticClass: "grade-select",
                  attrs: { size: "small" },
                  on: { change: _vm.loadReport },
                  model: {
                    value: _vm.selectedGrade,
                    callback: function ($$v) {
                      _vm.selectedGrade = $$v
                    },
                    expression: "selectedGrade",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "Tất cả các khối", value: "" },
                  }),
                  _vm._l(_vm.gradeOptions, function (grade) {
                    return _c("el-option", {
                      key: grade.gradeId,
                      attrs: {
                        label: grade.gradeName,
                        value: String(grade.gradeId),
                      },
                    })
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm.errorMessage
        ? _c("el-alert", {
            attrs: {
              title: _vm.errorMessage,
              type: "error",
              closable: false,
              "show-icon": "",
            },
          })
        : _vm._e(),
      !_vm.loading && !_vm.errorMessage && !_vm.hasData
        ? _c("el-alert", {
            attrs: {
              title: "Chưa có dữ liệu thống kê thực đơn",
              type: "info",
              closable: false,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _vm.hasData
        ? [
            _vm.isHistoricalWeek
              ? _c("p", { staticClass: "roster-note" }, [
                  _vm._v(
                    "Số lớp của tuần cũ được đối chiếu theo danh sách lớp hiện tại."
                  ),
                ])
              : _vm._e(),
            _c("div", { staticClass: "menu-kpi-grid" }, [
              _c("div", { staticClass: "menu-kpi-card border-indigo" }, [
                _vm._m(3),
                _c("div", { staticClass: "kpi-details" }, [
                  _c("span", { staticClass: "kpi-name" }, [
                    _vm._v("Tổng số lớp học"),
                  ]),
                  _c("div", { staticClass: "kpi-number text-indigo" }, [
                    _vm._v(_vm._s(_vm.report.totalClasses) + " "),
                    _c("span", { staticClass: "kpi-unit" }, [_vm._v("lớp")]),
                  ]),
                  _c("div", { staticClass: "kpi-hint" }, [
                    _vm._v(_vm._s(_vm.selectedGradeLabel)),
                  ]),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass: "menu-kpi-card border-emerald interactive-card",
                  on: {
                    click: function ($event) {
                      return _vm.openMenuDialog("published")
                    },
                  },
                },
                [
                  _vm._m(4),
                  _c("div", { staticClass: "kpi-details" }, [
                    _vm._m(5),
                    _c("div", { staticClass: "kpi-number text-emerald" }, [
                      _vm._v(_vm._s(_vm.report.publishedClasses) + " "),
                      _c("span", { staticClass: "kpi-unit" }, [_vm._v("lớp")]),
                    ]),
                    _c("div", { staticClass: "kpi-hint text-emerald" }, [
                      _c("i", { staticClass: "el-icon-check" }),
                      _vm._v(
                        " Đạt " +
                          _vm._s(_vm.report.publishRate.toFixed(1)) +
                          "%"
                      ),
                    ]),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "menu-kpi-card border-rose interactive-card",
                  on: {
                    click: function ($event) {
                      return _vm.openMenuDialog("unpublished")
                    },
                  },
                },
                [
                  _vm._m(6),
                  _c("div", { staticClass: "kpi-details" }, [
                    _vm._m(7),
                    _c("div", { staticClass: "kpi-number text-rose" }, [
                      _vm._v(_vm._s(_vm.report.unpublishedClasses) + " "),
                      _c("span", { staticClass: "kpi-unit" }, [_vm._v("lớp")]),
                    ]),
                    _c("div", { staticClass: "kpi-hint text-rose" }, [
                      _c("i", { staticClass: "el-icon-bell" }),
                      _vm._v(
                        " Còn " +
                          _vm._s(_vm.report.unpublishedRate.toFixed(1)) +
                          "% cần nộp"
                      ),
                    ]),
                  ]),
                ]
              ),
            ]),
            _c(
              "el-row",
              { staticClass: "charts-row", attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { xs: 24, sm: 24, md: 14, lg: 15 } }, [
                  _c("div", { staticClass: "chart-card h-100" }, [
                    _c("div", { staticClass: "chart-card-head" }, [
                      _c("div", [
                        _c("h3", { staticClass: "chart-title" }, [
                          _vm._v("Tình Hình Đăng Thực Đơn Theo Khối"),
                        ]),
                        _c("p", { staticClass: "chart-subtitle" }, [
                          _vm._v(
                            _vm._s(_vm.weekRangeLabel) +
                              " • So sánh số lớp đã đăng và chưa đăng theo khối"
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "chart-legend-chips" }, [
                        _c("span", { staticClass: "legend-dot-item" }, [
                          _c("span", { staticClass: "chip-color chip-pub" }),
                          _vm._v(" Đã đăng"),
                        ]),
                        _c("span", { staticClass: "legend-dot-item" }, [
                          _c("span", { staticClass: "chip-color chip-unpub" }),
                          _vm._v(" Chưa đăng"),
                        ]),
                      ]),
                    ]),
                    _vm.gradeStats.length
                      ? _c("div", { staticClass: "grade-chart-scroll" }, [
                          _c("div", {
                            ref: "chartGradeMenu",
                            staticClass: "grade-chart",
                            style: { width: _vm.gradeChartWidth },
                          }),
                        ])
                      : _c("p", { staticClass: "grade-chart-empty" }, [
                          _vm._v("Không có lớp trong phạm vi đang chọn."),
                        ]),
                  ]),
                ]),
                _c("el-col", { attrs: { xs: 24, sm: 24, md: 10, lg: 9 } }, [
                  _c(
                    "div",
                    { staticClass: "chart-card h-100 gauge-container-card" },
                    [
                      _c("div", { staticClass: "chart-card-head" }, [
                        _c("div", [
                          _c("h3", { staticClass: "chart-title" }, [
                            _vm._v(
                              "Tỷ Lệ Hoàn Thành " +
                                _vm._s(
                                  _vm.selectedGrade
                                    ? _vm.selectedGradeLabel
                                    : "Toàn Trường"
                                )
                            ),
                          ]),
                          _c("p", { staticClass: "chart-subtitle" }, [
                            _vm._v("Tiến độ cập nhật thực đơn tuần"),
                          ]),
                        ]),
                        _c(
                          "span",
                          {
                            staticClass: "gauge-status-badge",
                            class:
                              _vm.report.publishRate >= 80
                                ? "badge-good"
                                : "badge-warn",
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.report.publishRate >= 80
                                    ? "Tiến độ tốt"
                                    : "Cần đôn đốc"
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]),
                      _c("div", {
                        ref: "chartGaugeMenu",
                        staticClass: "gauge-chart-box",
                      }),
                      _c("div", { staticClass: "gauge-summary-footer" }, [
                        _c("div", { staticClass: "gauge-summary-stat" }, [
                          _c("span", { staticClass: "stat-lbl" }, [
                            _vm._v("Đã hoàn thành"),
                          ]),
                          _c(
                            "strong",
                            { staticClass: "stat-val text-emerald" },
                            [
                              _vm._v(
                                _vm._s(_vm.report.publishedClasses) + " lớp"
                              ),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "gauge-divider" }),
                        _c("div", { staticClass: "gauge-summary-stat" }, [
                          _c("span", { staticClass: "stat-lbl" }, [
                            _vm._v("Còn thiếu"),
                          ]),
                          _c("strong", { staticClass: "stat-val text-rose" }, [
                            _vm._v(
                              _vm._s(_vm.report.unpublishedClasses) + " lớp"
                            ),
                          ]),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "quick-action-strip" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "mini",
                                plain: "",
                                icon: "el-icon-circle-check",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openMenuDialog("published")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              Danh sách đã đăng (" +
                                  _vm._s(_vm.report.publishedClasses) +
                                  ")\n            "
                              ),
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "danger",
                                size: "mini",
                                plain: "",
                                icon: "el-icon-warning",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openMenuDialog("unpublished")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              Danh sách chưa đăng (" +
                                  _vm._s(_vm.report.unpublishedClasses) +
                                  ")\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
              ],
              1
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  visible: _vm.dialogVisible,
                  width: "60%",
                  top: "7vh",
                  "custom-class": "modern-menu-dialog",
                  "destroy-on-close": true,
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.dialogVisible = $event
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "dialog-custom-header",
                    attrs: { slot: "title" },
                    slot: "title",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "header-icon-box",
                        class:
                          _vm.activeTab === "published"
                            ? "box-emerald"
                            : "box-rose",
                      },
                      [
                        _c("i", {
                          class:
                            _vm.activeTab === "published"
                              ? "el-icon-circle-check"
                              : "el-icon-warning-outline",
                        }),
                      ]
                    ),
                    _c("div", [
                      _c("h3", { staticClass: "dialog-heading" }, [
                        _vm._v(
                          _vm._s(
                            _vm.activeTab === "published"
                              ? "Danh Sách Các Lớp Đã Đăng Thực Đơn"
                              : "Danh Sách Các Lớp Chưa Đăng Thực Đơn"
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "dialog-subheading" }, [
                        _vm._v(
                          _vm._s(_vm.weekRangeLabel) +
                            " • " +
                            _vm._s(_vm.selectedGradeLabel)
                        ),
                      ]),
                    ]),
                  ]
                ),
                _c("div", { staticClass: "dialog-tab-bar" }, [
                  _c(
                    "button",
                    {
                      class: [
                        "dialog-tab-btn",
                        { active: _vm.activeTab === "published" },
                      ],
                      on: {
                        click: function ($event) {
                          _vm.activeTab = "published"
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          Lớp đã đăng (" +
                          _vm._s(_vm.publishedList.length) +
                          ")\n        "
                      ),
                    ]
                  ),
                  _c(
                    "button",
                    {
                      class: [
                        "dialog-tab-btn",
                        "btn-danger-tab",
                        { active: _vm.activeTab === "unpublished" },
                      ],
                      on: {
                        click: function ($event) {
                          _vm.activeTab = "unpublished"
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          Lớp chưa đăng (" +
                          _vm._s(_vm.unpublishedList.length) +
                          ")\n        "
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "dialog-search-wrap" },
                    [
                      _c("el-input", {
                        staticClass: "dialog-search-input",
                        attrs: {
                          size: "small",
                          placeholder: "Tìm theo tên lớp hoặc khối",
                          "prefix-icon": "el-icon-search",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchQuery,
                          callback: function ($$v) {
                            _vm.searchQuery = $$v
                          },
                          expression: "searchQuery",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "dialog-table-container" },
                  [
                    _c(
                      "el-table",
                      {
                        staticClass: "modern-menu-table",
                        attrs: {
                          data: _vm.filteredDialogList,
                          stripe: "",
                          border: "",
                          size: "small",
                          "empty-text": "Không có lớp trong danh sách",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            type: "index",
                            label: "STT",
                            width: "55",
                            align: "center",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: { label: "Tên lớp", "min-width": "170" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "class-title-cell" },
                                      [
                                        _c(
                                          "strong",
                                          { staticClass: "text-indigo" },
                                          [_vm._v(_vm._s(scope.row.className))]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "sub-grade" },
                                          [_vm._v(_vm._s(scope.row.gradeName))]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2816445436
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "Kiểu thực đơn", "min-width": "135" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm.submissionTypeLabel(
                                          scope.row.submissionType
                                        )
                                      )
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2432230394
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "Ngày còn thiếu",
                            "min-width": "180",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm.missingDatesLabel(
                                          scope.row.missingDates
                                        )
                                      )
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1801288122
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "Cập nhật gần nhất",
                            "min-width": "150",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatDateTime(scope.row.updatedAt)
                                      )
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3678721310
                          ),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer",
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: {
                          click: function ($event) {
                            _vm.dialogVisible = false
                          },
                        },
                      },
                      [_vm._v("Đóng")]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header-title-group" }, [
      _c("div", { staticClass: "header-icon-badge" }, [
        _c("i", { staticClass: "el-icon-dish" }),
      ]),
      _c("div", [
        _c("h2", { staticClass: "header-title" }, [
          _vm._v("Thống Kê Thực Đơn & Tiến Độ Đăng Khẩu Phần Ăn"),
        ]),
        _c("p", { staticClass: "header-subtitle" }, [
          _vm._v("Theo dõi tiến độ hoàn thành thực đơn tuần của các lớp"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "chip-label" }, [
      _c("i", { staticClass: "el-icon-date" }),
      _vm._v(" Chọn tuần:"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "chip-label" }, [
      _c("i", { staticClass: "el-icon-collection-tag" }),
      _vm._v(" Khối:"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "kpi-icon-wrap bg-indigo-soft text-indigo" },
      [_c("i", { staticClass: "el-icon-s-home" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "kpi-icon-wrap bg-emerald-soft text-emerald" },
      [_c("i", { staticClass: "el-icon-circle-check" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "kpi-title-row" }, [
      _c("span", { staticClass: "kpi-name" }, [_vm._v("Số lớp đã đăng")]),
      _c("span", { staticClass: "click-hint-badge text-emerald" }, [
        _vm._v("Xem chi tiết "),
        _c("i", { staticClass: "el-icon-arrow-right" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "kpi-icon-wrap bg-rose-soft text-rose" }, [
      _c("i", { staticClass: "el-icon-warning-outline" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "kpi-title-row" }, [
      _c("span", { staticClass: "kpi-name" }, [_vm._v("Số lớp chưa đăng")]),
      _c("span", { staticClass: "click-hint-badge text-rose" }, [
        _vm._v("Xem chi tiết "),
        _c("i", { staticClass: "el-icon-arrow-right" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }